import './main.scss';
import React from 'react';
import { Navigate } from 'react-router-dom';
import Header from '../../../organisms/header/header';
import decodeToken from '../../../../utils/decode-token';
import TableHacShippingAdmin from '../../../organisms/shipping-admin/table-hac-shipping-admin/table-hac-shipping-admin';

function MainShippingAdmin() {

  const token = sessionStorage.getItem('token') || null;
  const role = token ? decodeToken(token).role : null;

  return (
    <>
      {token && role === 'shippingAdmin' ? (
        <div className="App">
          <Header />
          <main>
            <section>
              <div className="inner">
                <TableHacShippingAdmin />
              </div>
            </section>
          </main>
        </div>
      ) : (
        <Navigate to="/login" />
      )}
    </>
  );
}

export default MainShippingAdmin;
